var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DiscountRatesTableWidget',{attrs:{"assetTypes":_vm.assetTypes,"is-read-only-mode":_vm.isReadOnlyMode,"currencyCodes":_vm.currencyCodes,"currentDiscountRates":_vm.discountRates}})
}
var staticRenderFns = []

export { render, staticRenderFns }